module.exports = __webpack_public_path__ + "img/setting-fill.8c41510f.svg";